import Vue from 'vue';
import { mapGetters } from 'vuex';
import { routeOptionController } from '../routeVariablesSetter.mixin';
import brands from '@/store/modules/brands';

const routeHelperMixin = {
  name: 'routeHelperMixin',
  computed: {
    ...mapGetters(['getBrandUnitIdVariables']),
  },

  methods: {
    goNextStep(nextStep, params = {}) {
      const routeName = routeOptionController(nextStep);
      const unitId = this.getBrandUnitIdVariables.unitId;
      const brandId = this.getBrandUnitIdVariables.brandId;

      const isBrandAlta = brands.state[brandId]?.name === 'alta';

      if (routeName === 'checkIn') {
        params = { brandId, unitId };
      }

      if (isBrandAlta) {
        const body = brands.state[brandId][nextStep];
        params.body = body;
      }
      this.$router.push({
        name: routeName,
        params,
      });
    },
  },
};

Vue.mixin(routeHelperMixin);

export default routeHelperMixin;
